
<h2 mat-dialog-title>{{'interfaces.createToken' | translate}}</h2>

<mat-dialog-content>
    <div class="pt-2 pb-3">
        <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
            <form [formGroup]="tokenForm">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Token Name</mat-label>
                    <input formControlName="displayName" type="text" matInput placeholder="{{'interfaces.name' | translate}}">
                </mat-form-field>
            </form>
        </section>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" (click)="dialogCancel();"> {{'cancel' | translate}} </button>
    <button mat-button class="orange-button" (click)="dialogSave();">{{'save' | translate}}</button>
</mat-dialog-actions>
